export type PaymentType = 'sepa_debit' | 'card' | 'no_payment_method'
export type PaymentStatus =
  | 'succeeded'
  | 'requires_payment_method'
  | 'processing'
  | 'canceled'
  | 'requires_setup_intent'
  | 'requires_payment_intent'
  | 'no_status'

export interface PaymentMethodInterface {
  type: PaymentType
  readonly card?: Card
  readonly sepa?: Sepa
  readonly vatNumber: string
  readonly nextPayment: number
  readonly status: string
  readonly invoiceEmail?: string
  readonly intent?: Intent
  readonly payment_status: PaymentStatus
  readonly dueInvoices?: DueInvoice[]
  readonly disputesInfo?: PaymentDisputeInfoInterface[]
  readonly nextPaymentAmount?: number
}

export interface DueInvoice {
  invoiceNumber: string
  currency: string
  dueDate: number
  amountDueInCents: number
  cancelDate: number
  periodStart: number
  periodEnd: number
  planName: string
  planBillingCycle: string
  originalInvoiceId?: string
  entityType?: string
  itemsQuantity: number
}

export interface Card {
  readonly brand: string
  readonly last4: string
  readonly expiry: string
}

export interface Sepa {
  readonly bankCode: string
  readonly bankCountry: string
  readonly last4: string
  readonly mandate: {
    readonly status: 'pending' | 'accepted' | 'refused'
    readonly mandateUrl: string
    readonly mandateRef: string
  }
  readonly owner: string
}

export interface Intent {
  client_secret: string
  amount?: number
  currency?: string
  id: string
  paymentMethodId?: string
}

export interface PaymentDisputeInfoInterface {
  SEPALast4: string
  cardLast4: string
  disputeCount: number
  invoiceNumber: string
  dueDate: number
  paymentDate: number
  disputeDate: number
  periodStart: number
  periodEnd: number
  paymentAmount: number
  disputeFee: number
  totalDueAmount: number
  currency: string
  planName: string
  planId: string
  cancelDate: number
  originalInvoiceDueDate: number
  planBillingCycle: string
  entityType?: string
  itemsQuantity?: string
}
